import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Company, CompanyStatus, GetUserByIdRequest, IdentityWebApiClient, UpdateCompanyStatusRequest, User } from 'identity-webapi-client';
import { AuthService, BreadcrumbService } from 'src/app/services';

@Component({
  selector: 'app-approve-new-user',
  templateUrl: './approve-new-user.component.html',
  styleUrls: ['./approve-new-user.component.scss']
})
export class ApproveNewUserComponent implements OnInit {
  user: User = new User;
  company: Company = new Company;
  companyType: string | undefined;
  userPosition: string | undefined;
  isNewCompany: boolean = false;

  private _loading = false;
  public get loading(): boolean {
    return this._loading;
  }

  public set loading(val: boolean) {
    this._loading = val;
    this.breadcrumbService.setIsLoading(val);
  }

  constructor(
    private identityWebApiClient: IdentityWebApiClient,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private breadcrumbService: BreadcrumbService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    let userIdParam = this.route.snapshot.paramMap.get('userId');
    this.isNewCompany = !!this.route.snapshot.url.find(x => x.path === 'approve-new-company-user')
    this.loading = true;
    try {
      this.identityWebApiClient.getUserById({
        id: userIdParam
      } as GetUserByIdRequest
      ).then(response => {
        if (response.success) {
          this.user = response.user ?? new User;
          this.userPosition = this.user.position?.toString();
          this.identityWebApiClient.getCompanyById(
            response.user?.companyId ?? ""
          ).then(response => {
            switch (this.user.position) {
              case 0: this.userPosition = 'Owner'; break;
              case 1: this.userPosition = 'Director'; break;
              case 2: this.userPosition = 'Manager'; break;
              default: throw new Error(`Unexpected user position (${this.user.position}) encountered`);
            }

            this.breadcrumbService.setParam('companyName', this.user.companyName);
            this.breadcrumbService.setParam('userName', `${this.user.firstName} ${this.user.lastName}`.trim());
            if (response.success) {
              this.company = response.company ?? new Company;
              switch (this.company.type) {
                case 0: this.companyType = 'Builder'; break;
                case 1: this.companyType = 'Manufacturer'; break;
                case 2: this.companyType = 'Architecture'; break;
                default: throw new Error(`Unexpected company type (${this.company.type}) encountered`);
              }
            }
            else {
              this.displaySnackBar("Unable to company for user");
            }
          })
        }
        else {
          this.displaySnackBar("Unable to load user");
        }
      })
    }
    finally {
      this.loading = false;
    }
  }
  displaySnackBar(message: string) {
    this.snackBar.open(message, 'OK', { duration: 2000 });
  }

  approveClick() {
    this.updateCompanyStatus(CompanyStatus.Approved);
  }

  denyClick() {
    this.updateCompanyStatus(CompanyStatus.Rejected);
  }

  updateCompanyStatus(companyStatus: CompanyStatus) {
    this.identityWebApiClient.updateCompanyStatus({
      userId: this.user.id,
      status: companyStatus
    } as UpdateCompanyStatusRequest).then(response => {
      if (response.success) {
        this.displaySnackBar("Company status updated");
      }
      else {
        this.displaySnackBar("Unable update company status");
      }
    });
  }
}
